import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FieldItem } from 'src/app/models/common/field-item';
import { BaseService } from 'src/app/system-common/services/base.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import imageCompression from 'browser-image-compression';
import { map } from 'rxjs/internal/operators/map';

declare const openModal: any;

interface Node {
  name: string;
  value: number;
  evaluationDtlId: string;
  children?: Node[];
  showChildren?: boolean;
}

export class AgentServiceHandler extends BaseService {
  isAuditButtonClicked: boolean;
  forAuditSearchList: boolean;
  productionName: any;
  designationArr: any = [];
  dashboardBalance: any;
  branchName: any = [];
  public selectedStepIndex: any;
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, 'AGENT');
  }

  public init(modelNameList: string[]) {
    return this.getAgent(0, modelNameList);
  }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean) {
    this.getStepIndex();
    return this.getAgent(id, modelNameList, isMetadataReqd);
  }

  public process(id: any, modelNameList: string[]) {
    return this.saveAgent(id, modelNameList);
  }

  public find(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getAgentSearchList(executeSearch, searchCriteriaData);
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getSearchList('TrackAgentStage', executeSearch, searchCriteriaData);
  }

  public clear() {
    super.clear();
  }

  private getAgentSearchList(executeSearch?: boolean, searchCriteriaData?: any) {
    let searchName = '';
    if (
      this.settingService.getSessionStorageValue('ApplicationStatus') != null &&
      this.settingService.getSessionStorageValue('ApplicationStatus') != undefined
    ) {
      searchCriteriaData = JSON.parse(this.settingService.getSessionStorageValue('ApplicationStatus'));
      this.settingService.removeSessionStorage('ApplicationStatus');
    } else if (
      this.settingService.getSessionStorageValue('CheckerApplicationStatus') != null &&
      this.settingService.getSessionStorageValue('CheckerApplicationStatus') != undefined
    ) {
      searchCriteriaData = JSON.parse(this.settingService.getSessionStorageValue('CheckerApplicationStatus'));
      this.settingService.removeSessionStorage('CheckerApplicationStatus');
    } else if (
      this.settingService.getSessionStorageValue('AuditChanges') != null &&
      this.settingService.getSessionStorageValue('AuditChanges') != undefined
    ) {
      searchCriteriaData = JSON.parse(this.settingService.getSessionStorageValue('AuditChanges'));
      // this.settingService.removeSessionStorage('AuditChanges');
    } else {
      if (searchCriteriaData != undefined) {
        if (this.settingService.getSessionStorageValue('userTypeIE') == 'CHECK') {
          if (searchCriteriaData['PortalAgentDO.applicationStatusCd'] == null) {
            searchCriteriaData['PortalAgentDO.applicationStatusCd'] = 'Submitted';
          }
        } else if (this.forAuditSearchList) {
          if (searchCriteriaData['PortalSearchAuditDO.id'] == null) {
            searchCriteriaData = JSON.parse(this.settingService.getSessionStorageValue('AuditChanges'));
          }
        }
      }
    }

    if (this.settingService.getSessionStorageValue('userType') == 'MAKER-INTERNAL') {
      if (this.forAuditSearchList) {
        searchName = 'SearchAuditResult';
      } else {
        searchName = 'SearchRecruitmentStatus';
      }
    } else {
      if (this.forAuditSearchList) {
        searchName = 'SearchAuditResult';
      } else {
        searchName = 'SearchRecruitmentStatusChecker';
      }
    }
    return this.getSearchList(searchName, executeSearch, searchCriteriaData);
  }

  public getAgent(id: number, modelNameList: any, isMetadataReqd = true) {
    let body = this.getFetchBody(modelNameList, isMetadataReqd);
    let path = this.getURLValue('AGENT');
    if (id != 0) {
      return this.httpPost(`${path}/${id}`, body);
    } else if (id == 0) {
      return this.httpPost(`${path}`, body);
    }
  }

  getGenderForTitle(model: any): void {
    let title = model.titleCd;
    let respGender: any;
    let body = {
      mappingKey: 'TitleGender',
      drivingValue: title,
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadMappingData`, body, undefined, false).subscribe(
      (body) => {
        respGender = JSON.parse(JSON.stringify(body));
        model.genderCd = respGender.data.values[0].cd;
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getAgentSegmentation1ValueForChannel(item: FieldItem): void {
    let model = item.model;
    let channelCd = model.channelCd;
    let agentSegmentation1: any;
    let body = {
      mappingKey: 'ChannelAgentSegmentation1',
      drivingValue: channelCd,
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadMappingData`, body, undefined, false).subscribe(
      (body) => {
        agentSegmentation1 = JSON.parse(JSON.stringify(body));
        model.agentSegmentation1 =
          agentSegmentation1.data.values.length > 0 ? agentSegmentation1.data.values[0].cd : null;
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getAgentSegmentation1LookupForChannel(item: FieldItem): void {
    let model = item.model;
    let channelCd = model.channelCd;
    let agentSegmentation1: any;
    let body = {
      mappingKey: 'ChannelAgentSegmentation1',
      drivingValue: channelCd,
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadMappingData`, body, undefined, false).subscribe(
      (body) => {
        agentSegmentation1 = JSON.parse(JSON.stringify(body));

        if (agentSegmentation1.data.values.length > 0) {
          item.model.agentSegmentation1 = agentSegmentation1.data.values[0].cd;
          this.setItemOptions(item, agentSegmentation1.data.values);
        } else {
          item.model.agentSegmentation1 = null;
          this.setItemOptions(item, agentSegmentation1.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getAgentSegmentation2ValueForChannel(model: any): void {
    let title = model.channelCd;
    let agentSegmentation2: any;
    let body = {
      mappingKey: 'ChannelAgentSegmentation2',
      drivingValue: title,
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadMappingData`, body, undefined, false).subscribe(
      (body) => {
        agentSegmentation2 = JSON.parse(JSON.stringify(body));
        model.agentSegmentation2 =
          agentSegmentation2.data.values.length > 0 ? agentSegmentation2.data.values[0].cd : null;
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getAgentSegmentation2LookupForChannel(item: FieldItem): void {
    let model = item.model;
    let channelCd = model.channelCd;
    let agentSegmentation2: any;
    let body = {
      mappingKey: 'ChannelAgentSegmentation2',
      drivingValue: channelCd,
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadMappingData`, body, undefined, false).subscribe(
      (body) => {
        agentSegmentation2 = JSON.parse(JSON.stringify(body));

        if (agentSegmentation2.data.values.length > 0) {
          item.model.agentSegmentation2 = agentSegmentation2.data.values[0].cd;
          this.setItemOptions(item, agentSegmentation2.data.values);
        } else {
          item.model.agentSegmentation1 = null;
          this.setItemOptions(item, agentSegmentation2.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  private saveAgent(id, modelNameList) {
    let body = this.getPostBody(modelNameList, true);
    let path = id == 0 ? `${this.getURLValue('AGENT')}` : `${this.getURLValue('AGENT')}/${id}`;

    body['current_step'] = `${this.selectedStepIndex}`;

    return this.httpPut(path, body);
  }

  addImage(imageContent: string, document: any, fileName: string) {
    let body = {};
    // if (document.ocrCheckReqd == 'YES') {
    //   body = {
    //     imageContent: imageContent,
    //     serviceDocument: document,
    //   };
    // }

    body = {
      imageContent: imageContent,
      serviceDocument: document,
      fileName: fileName,
    };

    let path = this.getURLValue('AGENT');
    return this.httpPost(`${path}/${this.id}/addImage`, body);
  }

  addPartyIdentity(partyModel: any) {
    let response: any;
    let body = { Party: partyModel };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addPartyIdentity `, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, partyModel.IdentityList);
        newList.push(response.data.PartyIdentity);
        //need to change the entire array instance in order to reflect in the dom
        // let partyModelTemp = partyModel;
        // partyModel = undefined;
        // partyModel = partyModelTemp;
        partyModel.IdentityList = [];
        partyModel.IdentityList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getCityCd(item: FieldItem): void {
    let pinCode = item.model.pinCode;
    // let countryCd = item.model.countryCd;
    let respCityCd: any;
    let body = {
      onlineLookupKey: 'PINCODECITY',
      onlineFilterCond: {
        pinCode: pinCode,
        // 'pincodeCityStateMapDO.countryCd': countryCd,
      },
      offlineLookupKey: 'PINCODECITY',
      offlineFilterCond: {
        pinCode: pinCode,
        // countryCd: countryCd,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        respCityCd = JSON.parse(JSON.stringify(body));
        if (respCityCd.data.values.length > 0) {
          item.model.cityCd = respCityCd.data.values[0].desc;
          //this.setItemOptions(item, respCityCd.data.values);
        } else {
          item.model.cityCd = null;
          item.model.pinCode = null;
          //openModal('errorModal');
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getStateCd(item: FieldItem): void {
    let pinCode = item.model.pinCode;
    // let countryCd = item.model.countryCd;
    let respStateCd: any;
    let body = {
      onlineLookupKey: 'PINCODESTATE',
      onlineFilterCond: {
        pinCode: pinCode,
        // 'pincodeCityStateMapDO.countryCd': countryCd,
      },
      offlineLookupKey: 'PINCODESTATE',
      offlineFilterCond: {
        pinCode: pinCode,
        // countryCd: countryCd,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        respStateCd = JSON.parse(JSON.stringify(body));
        if (respStateCd.data.values.length > 0) {
          item.model.stateCd = respStateCd.data.values[0].cd;
          this.setItemOptions(item, respStateCd.data.values);
        } else {
          item.model.stateCd = null;
          this.setItemOptions(item, respStateCd.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getBranchName(item: FieldItem): void {
    let bankCd = item.model.bankName;

    let branchCode: any;
    let body = {
      onlineLookupKey: 'BANKBRANCH',
      onlineFilterCond: {
        'lkp.bankCd': bankCd,
      },
      offlineLookupKey: 'BANKBRANCH',
      offlineFilterCond: {
        bankCd: bankCd,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        branchCode = JSON.parse(JSON.stringify(body));
        if (branchCode.data.values.length > 0) {
          item.model.agentDetailDOField7 = branchCode.data.values.length > 0 ? branchCode.data.values[0].cd : null;
          item.model.branchName = branchCode.data.values[0].desc;
          this.setItemOptions(item, branchCode.data.values);
        } else {
          item.model.agentDetailDOField7 = null;
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getBankNameByIFSC(item: FieldItem): void {
    let ifscCd = item.model.ifscCd;

    let bankCode: any;
    let body = {
      onlineLookupKey: 'IFSCBANK',
      onlineFilterCond: {
        ifscCode: ifscCd,
      },
      offlineLookupKey: 'IFSCBANK',
      offlineFilterCond: {
        ifscCode: ifscCd,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        bankCode = JSON.parse(JSON.stringify(body));
        if (bankCode.data.values.length > 0) {
          item.model.bankName = bankCode.data.values.length > 0 ? bankCode.data.values[0].cd : null;
          item.model.bankName = bankCode.data.values[0].desc;
          this.setItemOptions(item, bankCode.data.values);
        } else {
          item.model.bankName = null;
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getBranchNameByIFSC(item: FieldItem): void {
    let ifscCd = item.model.ifscCd;
    let branchCode: any;
    let body = {
      onlineLookupKey: 'IFSCBRANCH',
      onlineFilterCond: {
        ifscCode: ifscCd,
      },
      offlineLookupKey: 'IFSCBRANCH',
      offlineFilterCond: {
        ifscCode: ifscCd,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        branchCode = JSON.parse(JSON.stringify(body));
        if (branchCode.data.values.length > 0) {
          item.model.branchName = branchCode.data.values.length > 0 ? branchCode.data.values[0].cd : null;
          item.model.branchName = branchCode.data.values[0].desc;

          this.branchName = branchCode.data.values;
          this.setItemOptions(item, branchCode.data.values);
        } else {
          item.model.branchName = null;
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getProductionName() {
    let body = {
      onlineLookupKey: 'PRODUCTIONNAME',
      offlineLookupKey: 'PRODUCTIONNAME',
    };
    return this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false);
  }

  getsubordinateDesignationRole() {
    let body = {};

    this.httpPost(
      `${this.getURLValue('DESIGNATION')}/subordinateDesignationRole`,
      body,
      undefined,
      false
    ).subscribe(
      (body) => {
        let designation = JSON.parse(JSON.stringify(body));
        this.designationArr = [];
        const designations = designation?.data?.SubordinateDesignationRole || [];
        this.designationArr = [{ designationCd: '', designationDescription: 'Select' }, ...designations];
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getBranchCode(item: FieldItem): void {
    let branchName = item.model.agentDetailDOField7;
    let branchCode: any;
    let body = {
      onlineLookupKey: 'BRANCHCODE',
      onlineFilterCond: {
        'intHieDO.branchName': branchName,
      },
      offlineLookupKey: 'BRANCHCODE',
      offlineFilterCond: {
        branchName: branchName,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        branchCode = JSON.parse(JSON.stringify(body));
        if (branchCode.data.values.length > 0) {
          item.model.branchId = branchCode.data.values.length > 0 ? branchCode.data.values[0].cd : null;
          //  this.setItemOptions(item, branchCode.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  public generateOTP(otpType: string, entityGuid: string): Observable<Object> {
    let response: any;
    let body = {
      otpType: otpType,
      entityGuid: entityGuid,
    };
    return this.httpPost(`${this.getURLValue(this.serviceURL)}/${this.id}/generateOTP`, body);
  }

  addPaymentDetail() {
    let response: any;
    let body = { Party: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addPayment`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        response.data.PaymentList.payeeName = this.responseIO.data.AgentParty.fullName
          ? this.responseIO.data.AgentParty.fullName
          : '';
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.PaymentList);
        newList.push(response.data.PaymentList);
        //need to change the entire array instance in order to reflect in the dom
        // let partyModelTemp = partyModel;
        // partyModel = undefined;
        // partyModel = partyModelTemp;
        this.responseIO.data.PaymentList = [];
        this.responseIO.data.PaymentList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addEducationDetail(partyModel: any) {
    let response: any;
    let body = { Party: partyModel };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addPartyEducation`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, partyModel.EducationList);
        newList.push(response.data.EducationList);
        //need to change the entire array instance in order to reflect in the dom
        // let partyModelTemp = partyModel;
        // partyModel = undefined;
        // partyModel = partyModelTemp;
        partyModel.EducationList = [];
        partyModel.EducationList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addTrainingDetail() {
    let response: any;
    let body = { Party: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addTraining`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.TrainingList);
        newList.push(response.data.TrainingList);
        //need to change the entire array instance in order to reflect in the dom
        // let partyModelTemp = partyModel;
        // partyModel = undefined;
        // partyModel = partyModelTemp;
        this.responseIO.data.TrainingList = [];
        this.responseIO.data.TrainingList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addExamDetail() {
    let response: any;
    let body = { Party: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addExam`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.ExamList);
        newList.push(response.data.ExamList);
        //need to change the entire array instance in order to reflect in the dom
        // let partyModelTemp = partyModel;
        // partyModel = undefined;
        // partyModel = partyModelTemp;
        this.responseIO.data.ExamList = [];
        this.responseIO.data.ExamList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addAgentExistingInsuranceAgencyDetails() {
    let response: any;
    let body = { Party: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addAgent`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.LicenseList);
        newList.push(response.data.LicenseList);

        this.responseIO.data.LicenseList = [];
        this.responseIO.data.LicenseList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addAgentNomineeDetails() {
    let response: any;
    let body = { Party: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addAgentNominee`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.NomineeList);
        newList.push(response.data.NomineeList);
        console.log(newList);

        this.responseIO.data.NomineeList = [];
        this.responseIO.data.NomineeList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addAgentFamilyDetails() {
    let response: any;
    let body = { Agent: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addAgentFamily`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.FamilyList);
        newList.push(response.data.FamilyList);
        console.log(newList);

        this.responseIO.data.FamilyList = [];
        this.responseIO.data.FamilyList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addAgentReferenceDetails() {
    let response: any;
    let body = { Agent: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addAgentReference`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.ReferenceList);
        newList.push(response.data.ReferenceList);
        console.log(newList);

        this.responseIO.data.ReferenceList = [];
        this.responseIO.data.ReferenceList = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  addAgentHierarchyDetails() {
    let response: any;
    let body = { Party: this.responseIO.data };
    this.httpPost(`${this.getURLValue('AGENT')}/${this.id}/addAgentHierarchy`, body).subscribe(
      (body) => {
        response = JSON.parse(JSON.stringify(body));
        let newList = [];
        Array.prototype.push.apply(newList, this.responseIO.data.AgentDetail);
        newList.push(response.data.AgentDetail);

        this.responseIO.data.AgentDetail = [];
        this.responseIO.data.AgentDetail = newList;
        this.refreshMetaData(response);
      },

      (error) => {
        console.log('Error:', error);
      }
    );
  }

  submitAgent() {
    let body = {
      FormData: {
        Models: this.responseIO.data,
      },
    };

    return this.httpPost(`${this.getURLValue('AGENT')}/${this.id}`, body, {
      key: 'action',
      value: 'completeCurrentTask',
    });
  }

  populateOCRData(imageContent: string) {
    let body = {
      ImageContent: imageContent,
      Party: this.responseIO.data.AgentParty,
    };
    let path = this.getURLValue('AGENT');
    return this.httpPost(`${path}/populateOCRData`, body, null, true);
  }

  getAgentApplicationStatus() {
    let body = {};
    let path = this.getURLValue('AGENT');
    return this.httpPost(`/api/agents/agentApplicationSummary`, body, null, true);
  }

  getAgentPerformanceStatus(event: string, startDate?: any, endDate?: any) {
    let body = {
      event: event,
      startDate: startDate,
      endDate: endDate,
    };
    let path = this.getURLValue('AGENT');
    return this.httpPost(`/api/agents/agentPerformanceSummary`, body, null, true);
  }

  getAgentProductionSummary(productionName, month, year) {
    let body = {
      productionName: productionName,
      periodMonth: month,
      periodYear: year,
    };
    let path = this.getURLValue('PRODUCTION');
    return this.httpPost(`${path}/dashboard`, body, null, true);
  }

  getAgentPerformance(productionName, month, year) {
    let body = {
      productionName: productionName,
      periodMonth: month,
      periodYear: year,
    };
    let path = this.getURLValue('PRODUCTION');
    return this.httpPost(`${path}/agentPerformance`, body, null, true);
  }

  getCustomAgentPerformance(productionName, startDate, endDate, frequency, month, year) {
    let body = {
      productionName: productionName,
      startDate: startDate,
      endDate: endDate,
      frequency: frequency,
      periodMonth: month,
      periodYear: year,
    };
    let path = this.getURLValue('PRODUCTION');
    return this.httpPost(`${path}/customDatePerformance`, body, null, true);
  }

  getAgentProfile(id) {
    let path = this.getURLValue('AGENT');

    if (id == null) {
      let userLoginData = JSON.parse(this.settingService.getSessionStorageValue('userLoginData'));
      id = userLoginData.agentId;
    }
    return this.httpGet(`${this.getURLValue('AGENT')}?agentId=${id}`);
  }

  deleteAgent(id: number): Observable<Object> {
    let body = { id: id };
    return this.httpPost(`${this.getURLValue('AGENT')}/${id}/deleteAgent`, body);
  }

  deleteAgents(ids: any[]): Observable<Object> {
    let body = { id: ids.join(',') };
    return this.httpPost(`${this.getURLValue('AGENT')}/deleteAgent`, body);
  }

  getNoteHistory(guid: any) {
    let body = {
      entityGuid: guid,
    };
    return this.httpPost(`${this.getURLValue('NOTES')}/getNotesHistory`, body);
  }

  addNote(guid) {
    let body = {
      entityGuid: guid,
    };
    return this.httpPost(`${this.getURLValue('NOTES')}/addNote`, body);
  }

  saveNote(responseData) {
    let body = { Notes: responseData };
    return this.httpPost(`${this.getURLValue('NOTES')}/saveNote`, body);
  }

  async compressImage(event) {
    let imageFile = event.target.files[0];
    console.log(`Original Image Size ${imageFile.size / 1024 / 1024} MB`);

    let options = {
      maxSizeMB: 1, //maxSizeMB should not be less than 1.
      maxWidthOrHeight: 1000, //maxWidthOrHeight helps to reduce file size and dimension.
      useWebWorker: true,
      alwaysKeepResolution: true,
    };
    try {
      let compressedFile = await imageCompression(imageFile, options);
      // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
      console.log(`Compressed File Size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

      return compressedFile;
    } catch (error) {
      console.error(error);
    }
  }

  getDashboardBalance() {
    let body = {};
    let path = '/api/dashboardBalance';

    return this.httpPost(`${path}/getDashboardBalance`, body);
  }

  getSupervisorDetails() {
    let modelNameList = ['Entity', 'SupervisorDetail'];
    let body = this.getFetchBody(modelNameList, true);
    let path = '/api/supervisor';

    return this.httpPost(`${path}`, body, {
      key: 'action',
      value: 'find',
    });
  }

  getApplicationStatusLookup() {
    let body = {
      onlineLookupKey: 'APPLICATIONSTATUS',
      offlineLookupKey: 'APPLICATIONSTATUS',
    };
    return this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false);
  }

  getTreeData(): Observable<Node[]> {
    var apiUrl = '/api/evaluation/getTreeData';
    let evaluationId = 'BEN_1337001';
    var requestBody = {
      evaluationId: evaluationId,
    };
    return this.httpPost(apiUrl, requestBody).pipe(map((response) => this.transformToNodes(response['data'])));
  }

  private transformToNodes(data: any): Node[] {
    return Object.keys(data).map((key) => this.transformNode(key, data[key]));
  }

  private transformNode(key: string, value: any): Node {
    const nameMatch = key.match(/(.*?) \((\d+(\.\d+)?)\) \((.*?)\)$/);
    const name = nameMatch ? nameMatch[1] : key;
    const nodeValue = nameMatch ? parseInt(nameMatch[2], 10) : 0;
    const evaluationDtlId = nameMatch[4];

    const node: Node = {
      name: name,
      value: nodeValue,
      evaluationDtlId: evaluationDtlId,
      showChildren: false,
    };

    if (value && typeof value === 'object') {
      node.children = this.transformToNodes(value);
    }

    return node;
  }

  public getStepIndex() {
    this.selectedStepIndex =
      this.currentActiveStepObj && this.currentActiveStepObj.index != undefined
        ? this.currentActiveStepObj.index
        : null;
  }

  getEndorsementConfiguration() {
    let body = {};
    return this.httpPost(`/api/agent/getEndorsementConfiguration`, body);
  }

  updateAgentDetails(payload: any): Observable<any> {
    return this.httpPost(`/api/agent/updateAgentDetails`, payload);
  }
}
